module.exports = __webpack_public_path__ + "static/media/patient-submit-success-icon.fcf20881.png";